var map = {
	"./Acala Armor.png": 9600,
	"./Aoki's Kiss.png": 8817,
	"./Ashigaru Armor.png": 9765,
	"./Azure Divine Bell.png": 7636,
	"./Blossom Shuriken.png": 3562,
	"./Broken Flag.png": 4334,
	"./Colorful Hyorogan.png": 637,
	"./Counterfeit Wallet.png": 3849,
	"./Courage Taiko.png": 910,
	"./Daruma - Evil.png": 2424,
	"./Daruma - Kind.png": 4908,
	"./Daruma Oni.png": 2136,
	"./Daruma Panda.png": 7743,
	"./Daruma Princess.png": 956,
	"./Demon Hound's Teeth.png": 4877,
	"./Devileye Ring.png": 1589,
	"./Dragon Blood Scarf.png": 8202,
	"./Dragon Bone Horn.png": 3901,
	"./Dragon Fang Armlets.png": 3717,
	"./Dragon Scale Armor.png": 2648,
	"./Dragon Spirit Mask.png": 1264,
	"./Eagle Claw Boots.png": 1637,
	"./Envenomed Shuriken.png": 305,
	"./Fire Rattle.png": 1048,
	"./Fire Ring.png": 5706,
	"./Fire Shuriken.png": 622,
	"./Flag.png": 5347,
	"./Flame Dragon Soul Lantern.png": 8025,
	"./Flame Scroll.png": 3806,
	"./Flame Soul Flag.png": 6729,
	"./Four Symbols Amulet.png": 3438,
	"./Fox Spirit Bell.png": 3099,
	"./Frost Moon Case.png": 6293,
	"./Frozen Feather.png": 5808,
	"./Furinkazan Flag.png": 7970,
	"./Hyorogan.png": 9905,
	"./Ice Fox Pendant.png": 5780,
	"./Ice Scroll.png": 5985,
	"./Ice Spirit Mirror.png": 8368,
	"./Jade Fox Folding Fan.png": 3937,
	"./Kamaitachi Contract.png": 7586,
	"./Land of Steam Technician.png": 3428,
	"./Lightning Ring.png": 3970,
	"./Lightning Shuriken.png": 2184,
	"./MVP Trophy.png": 1950,
	"./Master Mystique.png": 8848,
	"./Mechanical Owl.png": 2980,
	"./Mighty Iron Helmet.png": 4894,
	"./Moon Grain Pot.png": 4695,
	"./Moonlit Calonyction.png": 4616,
	"./Ninjutsu Cheat Sheet.png": 4836,
	"./Ninjutsu Secret Scroll.png": 2903,
	"./Ninjutsu Shattered Scroll.png": 4262,
	"./Nioh Gauntlet.png": 7867,
	"./Nova Taiko.png": 1238,
	"./Nyanta Wallet.png": 2779,
	"./Oni Index.png": 7611,
	"./Pale Memories.png": 2318,
	"./Phoenix Jade Pendant.png": 7119,
	"./Pungent Sword Oil.png": 9533,
	"./Rattle Drum.png": 4209,
	"./Red Frog Oil.png": 5062,
	"./Red Lotus Crystal.png": 4133,
	"./Redemptive Echo.png": 8477,
	"./Regeneration Hormone.png": 8123,
	"./Seven Flame Rosary.png": 7760,
	"./Silver Owl Stealth Suit.png": 2104,
	"./Soul Elixir.png": 6140,
	"./Specter Steel Trap.png": 6146,
	"./Spoiled Hyorogan.png": 8149,
	"./Stealth Suit.png": 6732,
	"./Steel Gauntlet.png": 3079,
	"./Steel Shuriken.png": 5655,
	"./Super Charger.png": 1764,
	"./Super ElectroMagnetic Shoes.png": 748,
	"./Sword Oil.png": 4691,
	"./Tengu Mask.png": 415,
	"./Tengu's Fang.png": 8947,
	"./The Legend of Sword Master - Part I.png": 7042,
	"./The Legend of Sword Master - Part II.png": 7139,
	"./Thunder Dragon Orb.png": 2583,
	"./Thunder Dragon Sheath.png": 6423,
	"./Thunder Vajra.png": 611,
	"./Thunderbird Scroll.png": 3275,
	"./Tiger Teeth.png": 1874,
	"./Water Ring.png": 1063,
	"./Water Shuriken.png": 4825,
	"./Wind Blade Scroll.png": 1474,
	"./Wind Ring.png": 2202,
	"./Wind Shuriken.png": 8288,
	"./Wine Master's Gourd.png": 3740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2940;